import React from 'react';

const INK = '#0F0F0F';
const MUTED = '#595959';
const GOLD = '#D4AF37';

// Renders every body measurement 3DLOOK returned, verbatim, grouped by SAIA block.
export const ProviderMeasurements = ({ data }) => {
  const items = data?.items || [];
  const groups = items.reduce((acc, it) => {
    (acc[it.group] = acc[it.group] || []).push(it);
    return acc;
  }, {});
  const isMock = data?.source === 'mock';

  return (
    <div data-testid="provider-measurements">
      <div className="px-3 py-2 flex items-center justify-between" style={{ background: '#FAF9F6' }}>
        <p data-testid="provider-measurements-count" className="text-[10.5px]" style={{ color: INK }}>
          {items.length} measurements from 3DLOOK · original values in {data?.unit || 'cm'}
        </p>
        {isMock && (
          <span data-testid="provider-measurements-mock-badge" className="text-[9px] px-1.5 py-0.5"
            style={{ background: 'rgba(154,106,15,0.12)', color: '#9A6A0F', fontWeight: 600 }}>
            Demo data — not a real scan
          </span>
        )}
      </div>
      {Object.entries(groups).map(([group, rows]) => (
        <div key={group} data-testid={`provider-group-${rows[0].block}`}>
          <p className="px-3 pt-2.5 pb-1 text-[9.5px] tracking-[0.14em] uppercase" style={{ color: GOLD, fontWeight: 600 }}>
            {group} · {rows.length}
          </p>
          {rows.map(it => (
            <div key={it.key} className="px-3 py-1.5 flex items-center justify-between gap-2 border-b"
              style={{ borderColor: '#F5F5F5' }}>
              <p className="text-[12px] truncate" style={{ color: INK }}>{it.label}</p>
              <span data-testid={`provider-${it.key}`} className="text-[13px] tabular-nums"
                style={{ fontFamily: 'Playfair Display, serif', color: INK, fontWeight: 500 }}>
                {it.value} <span className="text-[9px]" style={{ color: MUTED }}>{it.unit}</span>
              </span>
            </div>
          ))}
        </div>
      ))}
      {(data?.unavailable || []).length > 0 && (
        <p data-testid="provider-measurements-unavailable" className="px-3 py-2 text-[10px]" style={{ color: MUTED }}>
          Not returned by 3DLOOK: {data.unavailable.map(u => u.key.split('.').pop().replace(/_/g, ' ')).join(', ')}
        </p>
      )}
    </div>
  );
};

export default ProviderMeasurements;
